import { render, staticRenderFns } from "./authLayout.vue?vue&type=template&id=5f8cb9ba&scoped=true"
import script from "./authLayout.vue?vue&type=script&lang=ts"
export * from "./authLayout.vue?vue&type=script&lang=ts"
import style0 from "./authLayout.vue?vue&type=style&index=0&id=5f8cb9ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8cb9ba",
  null
  
)

export default component.exports